import { Keyboard } from "@capacitor/keyboard";
import { isDefined } from "@clipboard-health/util-ts";

import { isCapacitorPlatform } from "./platformUtils";

export async function hideKeyboard() {
  const activeElement = document.activeElement as HTMLElement;

  if (isDefined(activeElement)) {
    activeElement.blur?.();
  }

  if (isCapacitorPlatform()) {
    Keyboard.hide().catch(() => {
      // Ignore errors
    });
  }
}
